/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.getAmazonProductVariants.internal

import kangaroorewards.appsdk.core.network.base.Endpoint

/**
 * The HTTP endpoint for the [GetAmazonProductVariantsApi].
 *
 * [Endpoint] has a single [Endpoint.path] parameter ex. "users/me"
 */
internal val GetAmazonProductVariantsEndpoint = Endpoint(path = "users/me/rewards/{rewardId}?include=external_products,external_product_variants&external_product_id={externalProductId}")
